// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"97712b6887211b365d08","655":"851e25c31228d9bfc52f"}[chunkId] + ".js";
};